import React from 'react';
import {MapPin,Store,Users,Globe2,Shirt,Baby,Footprints,ShoppingBag,House} from 'lucide-react';
import {useCareerLanguage} from './CareerLanguage';
import './CareerBrandPanel.css';

const facts=[['46','brandCities',MapPin],['85+','brandStores',Store],['2000+','brandEmployees',Users],['11','brandCountries',Globe2]];
const collections=[['brandWomen',Shirt],['brandMen',Shirt],['brandKids',Baby],['brandShoes',Footprints],['brandAccessories',ShoppingBag],['brandHome',House]];

export default function CareerBrandPanel({mobile=false}){
 const {t}=useCareerLanguage();
 return <aside className={mobile?'ca-company-mobile':'ca-brand ca-company'} aria-label={t('brandOverview')}>
  <div className="ca-company-heading">
   <div className="ca-company-wordmark" aria-label="Fulla Moda">fulla<span>moda</span></div>
   <p className="ca-company-slogan">{t('brandSlogan')}</p>
  </div>
  <dl className="ca-company-facts">{facts.map(([value,key,Icon])=><div key={key} className="ca-company-fact"><span className="ca-company-fact-icon" aria-hidden="true"><Icon size={20} strokeWidth={1.7}/></span><div><dt>{t(key)}</dt><dd>{value}</dd></div></div>)}</dl>
  <div className="ca-company-collections"><h3>{t('brandCategories')}</h3><ul>{collections.map(([key,Icon])=><li key={key}><Icon size={20} strokeWidth={1.6} aria-hidden="true"/><span>{t(key)}</span></li>)}</ul></div>
  <span className="ca-company-site"><Globe2 size={15} aria-hidden="true"/>www.fullamoda.com</span>
 </aside>;
}
